import { useState, useCallback } from 'react';
export function useToggle(initialState) {
    const [value, setState] = useState(initialState);
    return {
        value,
        toggle: useCallback(() => setState(state => !state), []),
        setTrue: useCallback(() => setState(true), []),
        setFalse: useCallback(() => setState(false), []),
    };
}
//# sourceMappingURL=useToggle.js.map